<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br>
                    <div>
                        <p class="texto2">¡Ya tienes una póliza activa!</p>
                        <br>
                        <p class="texto1">Hemos revisado tu situación y parece que ya tienes
                            una póliza<br>activa asociada a esa matrícula inmobiliaria :)</p>

                        <p class="texto1">Si necesitas hacer cambios en tu póliza actual o
                            tienes preguntas<br>sobre ella, no dudes en ponerte en contacto con nosotros.</p>
                    </div>

                    <img src="./assets/img/Cumulo.png" />
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/Cumulo.png" />
                    <br>
                    <div>
                        <p class="texto2">¡Ya tienes una póliza activa!</p>
                        <br>
                        <p class="texto1">Hemos revisado tu situación y parece que ya<br>
                            tienes una póliza activa asociada a esa<br>matrícula inmobiliaria :)</p>

                        <p class="texto1">Si necesitas hacer cambios en tu póliza<br>
                            actual o tienes preguntas sobre ella, no<br>
                            dudes en ponerte en contacto con nosotros.</p>
                    </div>
                </div>
                <br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="volverInicio()">
                        Volver al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>